import type { TFunction } from "i18next";
import * as yup from "yup";

export const getOptionalCheckboxSchema = (t: TFunction) =>
  yup.boolean().oneOf([false, true], t("COMMONS.ERRORS.REQUIRED")).default(false);
